import { useEffect } from 'react'
import { useParams } from '@tanstack/react-router'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { fetchBanner, updateBanner } from 'store/banners/bannersSlice'
import { getAllCustomBanners } from 'store/customBanners/customBannersSlice'
import { useAppDispatch, useAppSelector } from 'store/store'
import { EditBannerForm } from 'ui/components/EditBannerForm'

export const EditBannerPage = () => {
  const dispatch = useAppDispatch()
  const customBannersState = useAppSelector((state) => state.customBanners)
  const bannersState = useAppSelector((state) => state.banners)
  const { id } = useParams({
    from: '/protected/gestione-banner/$id/modifica',
  }) as { id: string }

  useEffect(() => {
    if (id) {
      const bannerId = parseInt(id, 10)
      if (!isNaN(bannerId)) {
        dispatch(fetchBanner(bannerId))
      }
    }
    dispatch(getAllCustomBanners())
  }, [dispatch, id])

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>
              Modifica Banner
            </h2>
            <p className='text-muted-foreground'>
              Modifica il banner selezionato
            </p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <div className='flex flex-col gap-5'>
            <EditBannerForm
              banner={bannersState.banner}
              onUpdate={(id, data) => {
                dispatch(updateBanner({ id, data }))
              }}
              customBanners={customBannersState.allBanners}
            />
          </div>
        </div>
      </Main>
    </>
  )
}

export default EditBannerPage
